(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * @ngdoc directive
     * @name ihh-common-web.prescription-content-view
     * @restrict E
     * @scope
     *
     * @param {object} prescription the prescription exercise objects
     * @param {String} prescriptionKey the key to access the prescription exercises by property name
     *
     * @description
     *  This directive is used to create the prescription content view page.
     *
     * @example
     * <prescription-content-view
     *  prescription="prescriptionTemplates"
     *  prescription-key="exerciseTemplates">
     * </prescription-content-view>
     */
    angular
        .module('ihh-common-web')
        .directive('prescriptionContentView', prescriptionContentView);

    prescriptionContentView.$inject = ['RxExUtilities', 'ResearchUtilities'];

    function prescriptionContentView(RxExUtilities, ResearchUtilities) {
        return {
            restrict: 'E',
            scope: {
                prescription: '=',
                prescriptionKey: '@'
            },
            templateUrl: 'prescription-content/prescription-content-view.tpl.html',
            link: function(scope) {
                scope.exerciseTemplates = scope.prescription[scope.prescriptionKey];
                scope.displayQuantityType = ResearchUtilities.displayQuantityType;
                scope.quantityTypes = RxExUtilities.getQuantityTypes();

                scope.getResistanceItemValue = function (exerciseTemplate) {
                    return RxExUtilities.getResistanceItemValue(exerciseTemplate);
                };

                scope.getQuantityType = function (exerciseTemplate) {
                    return RxExUtilities.getQuantityType(exerciseTemplate);
                };

                scope.getExerciseLinkUrl = function (exerciseTemplate) {
                    return RxExUtilities.getExerciseLinkUrl(exerciseTemplate, false);
                };

                scope.getExerciseThumbnailUrl = function (exerciseTemplate) {
                    return RxExUtilities.getExerciseThumbnailUrl(exerciseTemplate.exercise, false);
                };

                /**
                 * Returns whether the metronome value is considered set, either at the template or
                 * exercise, for the purpose of viewing.
                 * @param {type} exerciseTemplate the template
                 * @returns {Boolean} true if the metronome is set (even to zero)
                 */
                scope.isMetronome = function (exerciseTemplate) {
                    return exerciseTemplate.metronome >= 0 || exerciseTemplate.exercise.metronome >= 0;
                };

                /**
                 * Returns the effective value that should be displayed for the metronome.  If a value is set
                 * (including zero) at the template level then that is the value.  Otherwise, if a value is set
                 * at the exercise level than that is the value.  Otherwise undefined.
                 * @param {type} exerciseTemplate the template
                 * @returns {Number|undefined} The effective metronome or null or undefined if it is not present
                 */
                scope.getMetronome = function (exerciseTemplate) {
                    return exerciseTemplate.metronome >= 0 ? exerciseTemplate.metronome : exerciseTemplate.exercise.metronome;
                };
            }
        };
    }
})();